import React, { useEffect } from "react";
import { Box, Typography, Link, List, ListItem, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import TestimonialsCarousel from "../../components/TestimonialsCarousel/TestimonialsCarousel";
import JSU from "../../assets/JSU.png";
import MSU from "../../assets/MSU.png";
import Waveland from "../../assets/WavelandGZHMuseum.png";
import OHR from "../../assets/Ohr.webp";

const Workshop = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "Workshops - MS Digital Hub";
  }, []);
  const testimonialData = [
    {
      quote: `In just days, I gained years’ worth of wisdom. The Hub wasn’t just a learning experience; it was a masterclass in collaboration, purpose, and possibility. 
        
        Since returning, I’ve partnered with a colleague to begin developing the Africana Digital Humanities Lab on our campus.We’ve also started exploring ways to enrich the College of Liberal Arts through several of the tools, frameworks, and strategies shared during the hub.Although I’ve worked in digital humanities for years, this experience revealed an entire dimension I hadn’t yet seen.For the first time, I truly feel equipped and inspired to rethink my course structure in bold, innovative ways.
        
        For years, I’ve worked in digital humanities, often shaping projects with the tools and knowledge I had access to.But this program revealed an entirely new dimension, one that had been missing from my understanding.It wasn’t just about technology or theory, but about vision, structure, and radical imagination.In that space, I didn’t just learn; I saw possibility.The kind of digital humanities I had always longed for, interdisciplinary, community- engaged, creatively rigorous, suddenly felt within reach.Now, in building a new DH lab and rethinking our liberal arts landscape, I’m not just applying what I’ve learned.I’m co - authoring the kind of work I had always hoped existed.`,
      name: "Detrice Roberts",
      role: "Professor of History",
      company: "Jackson State University",
      logo: JSU,
    },
    {
      quote: `The USM Digital Humanities Summer Residency was an absolutely amazing experience. The two weeks were filled with learning about new tools and getting to play around with new approaches to Digital Humanities that I heard about but didn’t have the technical knowledge to accomplish. I was pretty confident with doing digital exhibits, but getting to learn more tools for the data-driven side of Digital Humanities was a lot of fun for me, especially the data visualization and mapping. Another part that was particularly helpful was the day spent talking about grants, which has always been a hard part of getting projects off the ground.
 
The tools and information that I gathered during the two weeks I brought back to my Digital Scholarship team, and we are already working on ways to incorporate them into the classroom, one idea being to work with one of our anthropology faculty members to expand a current project to include mapping the data from field study trips.  More projects will develop as the semester arrives and more discussions about project-based learning pick back up for the school year.
`,
      name: "KC New",
      role: "Interim Director of Research, Instruction, and Outreach",
      company: "Mississippi State University ",
      logo: MSU,
    },
    {
      quote: `The USM Digital Humanities Hub residency program introduced me to digitization techniques, best practices, and archival/special collections management. Our archive is slowly transforming from a filing cabinet of unsorted documents and photos to a carefully curated physical and digital repository that allows for easy location of collection items. This has been invaluable in planning future museum growth and makes the development of future exhibits much simpler. 

Additionally, I have begun to plan a project that uses digital humanities methods to breathe new life into one of our existing collections, increasing public engagement with the topic of Hurricane Katrina and Waveland history. This project would not be possible without my experience at the Hub's residency program, as it was my first introduction to topics such as GIS mapping, oral history collection, and grant writing, along with in-depth explorations of digitization, data management, and data visualization techniques that enhanced my existing knowledge and inspired me to try new methods. Without this expert-driven exploration of these topics in an environment that encouraged experimentation, hands-on learning, and creativity, my current project would not exist - the Hub opened my eyes to the potential of these static historical documents to become something narrative-driven, emotional, and dynamic.
`,
      name: "Claire Gray",
      role: "Digital Humanities Specialist/Intern",
      company: "Waveland’s Ground Zero Hurricane Museum ",
      logo: Waveland,
    },
    {
      quote:
        "I learned so many practical aspects and have already started applying them to the management and execution of digital projects. We were able to share ideas, ask questions, and learn from each other’s experiences in a really supportive environment",
      name: "Casey Sullivan",
      role: "Collections Manager and Registrar",
      company: "Ohr-O’Keefe Museum of Art",
      logo: OHR,
    },
    {
      quote:
        "The workshop nudged my humanities practice in really useful, practical ways… I’ve started layering different interpretive lenses (history + theme + audience) when I look at texts and objects, and that simple habit has opened up richer questions and conversations. I’m also using quicker, iterative feedback loops — sketching an idea, sharing it, then reworking it — which keeps projects moving and more collaborative. A particularly exciting addition has been experimenting with mapping tools to visualize connections across historical sites and cultural data, which adds a whole new dimension to research. The introduction to Python web development tools was another game-changer, offering fresh ways to structure and present information online. Even tiny tweaks, like reframing questions to invite more entry points or bringing short field-checks into research routines, have made my work clearer and more audience-centered. I’m excited to keep experimenting.",
      name: "Dr. Sade Turnipseed",
      role: "Assistant Professor of History",
      company: "Jackson State University",
      logo: JSU,
    },
  ];

  return (
    <Box
      sx={{
        width: "auto",

        padding: "0px 20px",
        margin: "0px auto",
        padding: { xs: "20px", sm: "30px", md: "1px 80px" },
        border: "none",
        backgroundColor: "#ffffff",
        borderRadius: "8px",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          marginBottom: "30px",
          textAlign: "center",
        }}
      >
        Upcoming Workshops and Training
      </Typography>
      <Typography
        variant="body1"
        sx={{
          marginBottom: "30px",
          lineHeight: "1.8",
          textAlign: "justify",
        }}
      >
        Through the support of a Congressionally funded grant and the National
        Historical Publications and Records Commission, the Hub is conducting
        workshops in the summers of 2025 (college and community college
        instructors), 2026 (secondary school educators), and 2027 (college and
        university students).
      </Typography>
      <Box sx={{ mt: 6, mb: 4 }}>
        <Box
          sx={{
            textAlign: "center",
            mb: 3,
          }}
        >
          <Typography
            variant="overline"
            sx={{
              letterSpacing: 2,
              textTransform: "uppercase",
              color: "text.secondary",
            }}
          >
            2025 Residency
          </Typography>

          <Typography
            variant="h5"
            sx={{
              fontWeight: 500,
              letterSpacing: 0.5,
              mt: 0.5,
            }}
          >
            Participant Voices
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ mt: 0.5, maxWidth: 520, mx: "auto" }}
          >
            Highlights from our 2025 Summer Residency
          </Typography>

          <Box
            sx={{
              mt: 1.5,
              mx: "auto",
              width: 80,
              height: 3,
              borderRadius: 999,
              bgcolor: "#FFD700",
            }}
          />
        </Box>

        <TestimonialsCarousel testimonials={testimonialData} />
      </Box>
    </Box>
  );
};

export default Workshop;
